import { render, staticRenderFns } from "./ProdSearch.vue?vue&type=template&id=50be7d8c&"
import script from "./ProdSearch.vue?vue&type=script&lang=js&"
export * from "./ProdSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports